import { get } from 'lodash';
import { useContext } from 'react';

import type { ContentItem, Reference } from '@swf/cms';
import { CMSContext } from '@swf/cms';

const useCMSReference = <T extends ContentItem>(reference?: Reference) =>
  get(useContext(CMSContext), reference?.uid || '') as T | undefined;

export default useCMSReference;
